import React, { useEffect } from "react";
import AOS from "aos";
//----------------------------------------------------
import styled from "styled-components";
import Carrousel from "./carrousel/carrousel";

const Services = () => {
  useEffect(() => {
    AOS.init({ duration: 1100, once: true });
  }, []);
  return (
    <Contenedor>
      <Carrousel></Carrousel>
    </Contenedor>
  );
};

export default Services;

const Contenedor = styled.div`
  padding: 2rem 0;
  background-color: rgb(9, 99, 184);
`;
